import type { FC, ReactNode } from 'react';

type NavBarBackgroundProps = {
  isExpanded?: boolean;
  children: ReactNode;
};

const NavBarBackground: FC<NavBarBackgroundProps> = ({ isExpanded, children }) => {
  return (
    <div
      className={`w-full flex lg:relative items-center justify-center bg-color-gray_light lg:bg-color-white z-10 lg:transition-[width] lg:duration-[250ms] ${
        isExpanded ? 'lg:w-[240px]' : 'lg:w-[72px]'
      }`}
      style={{ borderRight: '1px solid #E5ECEE' }}
    >
      {children}
    </div>
  );
};

export default NavBarBackground;
